<app-nav></app-nav>
<main>
  <router-outlet />
</main>
<app-toast-container />
<app-confirmation-dialog-container />